import React, { memo } from 'react'
import { Path, Circle as _Circle, Rect } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 75 74"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Rect x={0.998} width={74.002} height={74} rx={37} fill="#FF4500" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m40.337 23.794-2.872 5.744c-3.103.076-6.09.818-8.603 2.224a4.629 4.629 0 0 0-3.08-1.168A4.761 4.761 0 0 0 21 35.375c0 1.594.85 3.188 2.125 4.038v.743C23.125 46 29.819 50.781 38 50.781c8.181 0 14.875-4.781 14.875-10.625v-.743C54.15 38.563 55 36.968 55 35.374a4.761 4.761 0 0 0-4.781-4.781 4.629 4.629 0 0 0-3.081 1.168c-2.202-1.232-4.768-1.954-7.457-2.165l2.038-3.997 2.682 1.384a3.438 3.438 0 0 0-.026.422c0 1.806 1.381 3.188 3.188 3.188 1.806 0 3.187-1.382 3.187-3.188 0-1.806-1.381-3.187-3.187-3.187-.91 0-1.713.35-2.285.93l-3.56-1.78c-.53-.319-1.168-.107-1.38.425Zm-9.775 15.3c0-1.806 1.382-3.188 3.188-3.188 1.806 0 3.188 1.382 3.188 3.188 0 1.806-1.382 3.187-3.188 3.187-1.806 0-3.188-1.381-3.188-3.187Zm13.388 6.162c-1.169.956-3.825 1.275-5.95 1.275s-4.781-.319-5.95-1.275c-.425-.319-.531-1.062-.212-1.487.318-.425 1.062-.532 1.487-.213.425.319 2.019.85 4.675.85 2.656 0 4.25-.531 4.675-.85.425-.319 1.169-.319 1.488.213.318.531.318 1.062-.213 1.487Zm-1.7-2.975c-1.806 0-3.188-1.381-3.188-3.187 0-1.806 1.382-3.188 3.188-3.188 1.806 0 3.188 1.382 3.188 3.188 0 1.806-1.382 3.187-3.188 3.187Z"
        fill="#fff"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconRedditCircle'

export const IconRedditCircle = memo<IconProps>(themed(Icon))
